import { createSelector } from 'reselect';
import { DeleteAssetsState } from './reducer';

export function createDeleteAssetsSelectors(rootStateSelector: (rootState) => DeleteAssetsState) {
  return {
    asset: createSelector(rootStateSelector, (state) => state.asset),
    loading: createSelector(rootStateSelector, (state) => state.loading),
  };
}
